import React from "react";
import {Button, useTheme} from "@material-ui/core";


export function ContentButton({
  children,
  disabled,
  onClick,
  color,
  style,
}: {
  children: React.ReactNode,
  disabled?: boolean,
  onClick: () => void,
  color?: "danger",
  style?: React.CSSProperties,
}) {
  const theme = useTheme();

  const styles = {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    ...style,
  };

  if (color === "danger") {
    styles["backgroundColor"] = "#F45858";
  }

  return (
    <Button
      variant="contained"
      color="primary"
      style={styles}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
